import SignIn from '../pages/user/auth/signin';
import SignUp from '../pages/user/auth/signup';
import ForgotPassword from '../pages/user/auth/forgotpassword';
import Users from '../pages/admin/users/users';
import ResetPassword from '../pages/user/auth/resetpassword';
import Home from '../pages/user/Home';
import Report from '../pages/admin/users/Report';
import PrivacyPolicy from '../components/user/layouts/privacyPolicy';

//routes without login
const appRoutes = [
  {
    path: '/',
    element: SignIn,
  },
  { path: '/signup', element: SignUp },
  { path: '/forgotpassword', element: ForgotPassword },
  { path: '/resetpassword/:id/:time', element: ResetPassword },
  { path: '/privacy-policy', element: PrivacyPolicy },
];

//user routes
const authRoutes = [{ path: '/dashboard', element: Home }];

//admin routes
const adminRoutes = [
  { path: '/admin/dashboard', element: Users },
  { path: '/admin/report', element: Report },
];

export { appRoutes, adminRoutes, authRoutes };
